export default __webpack_public_path__ + "static/apache-860462762d14ce990fa4dde0ea20f5aa.svg";